import { PreloaderHelper } from "shared/helpers";
import { Tutorial } from "shared/services/tutorials/tutorial";
import { Localizer } from "shared/localization";
import { SoundService } from "shared/services/sound.service";
import { LanguageService, TutorailNameSerivce } from "..";
import { BuildConfig } from "shared/config";
import config from "config";

export class DropProductTutorial {
    public static toggleDropProductTutorial(state: boolean, screen: PIXI.Container): void {
        const prefixes = BuildConfig.getConfig();

        const slides = [
            {
                //@ts-ignore
                img: `${subPath}assets/gif/tut_drop_product.gif`,
                text: LanguageService.getTranslation('loc_drop_product_tutorial')
            },
        ]
        const user = JSON.parse(localStorage.getItem('mbny_game_user'));
        const tutorial = document.getElementById('tutorial');
        const closeTutorial = document.getElementById('closeTutorial');
        const startBtn = document.getElementById('startLevel');
        if (!state) {
            screen.visible = true;
            PreloaderHelper.togglePreloader(false);
            tutorial.style.display = 'none';
            return;
        }

        if (user && user.tutorails.drop_product) {
            SoundService.toggleBgIntro(true, 0.5, true);
            PreloaderHelper.togglePreloader(false);
            screen.visible = true;
            tutorial.style.display = 'none';
        } else {
            document.getElementById('slider_nav').style.display = 'none';
            Tutorial.addContent(slides, screen)
            screen.visible = false;
            tutorial.style.display = 'flex';
            TutorailNameSerivce.changeName('dropProduct');

            closeTutorial.addEventListener('click', () => {
                SoundService.toggleBgIntro(true, 0.5, true);
                const user = JSON.parse(localStorage.getItem('mbny_game_user'));
                user.tutorails.drop_product = true;
                localStorage.setItem('mbny_game_user', JSON.stringify(user))
                tutorial.style.display = 'none';
                PreloaderHelper.togglePreloader(false);
                Tutorial.deleteNodes();
                screen.visible = true;
                if(!config.guest)Tutorial.saveTutorial(user.tutorails);
            })

            startBtn.addEventListener('click', () => {
                SoundService.toggleBgIntro(true, 0.5, true);
                const user = JSON.parse(localStorage.getItem('mbny_game_user'));
                user.tutorails.drop_product = true;
                localStorage.setItem('mbny_game_user', JSON.stringify(user));
                Tutorial.deleteNodes();
                tutorial.style.display = 'none';
                PreloaderHelper.togglePreloader(false);
                screen.visible = true;
                if(!config.guest)Tutorial.saveTutorial(user.tutorails);
            })
        }
    }
}